import React from "react";

export default function BranchHolidayList({
    holidays = [],
    formatDateLabel,
    formatDayLabel,
    getHolidayTypeLabel,
    onEdit,
    onDelete,
    isInactiveBranch
}) {
    const branchHolidayRows = [...(holidays || [])]
        .sort((a, b) =>
            (a?.start_date || a?.date || "").localeCompare(
                b?.start_date || b?.date || ""
            )
        );

    return (
        <div className="">
            <div className="flex mb-3 overflow-auto pb-[6px] scroll-bar" id="search-result" 
                style={{ maxHeight: 'calc(100vh - 305px)' }}>
                <table className="w-full" id="admin-table" class="stickyhead">
                    <thead>
                        <tr>
                            <th className="w-[15%] text-left">Date</th>
                            <th className="w-[15%] text-left">Day</th>
                            <th className="w-[30%] text-left">Holiday Name</th>
                            <th className="w-[15%] text-left">Type</th>
                            <th className="w-[20%] text-left">Actions</th>
                        </tr>
                    </thead>
                    {branchHolidayRows.length === 0 ? (
                        <tbody>
                            <tr>
                                <td
                                    colSpan={4}
                                    className="no-records-message"
                                    id="no-matching-result"
                                    style={{ lineHeight: "100px" }}
                                >
                                    No records found.
                                </td>
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            {branchHolidayRows.map((item) => {
                                const rowKey = item?.id || item?.date || `${item?.start_date}-${item?.end_date}`;

                                return (
                                    <tr key={rowKey} className="border-t">
                                        <td className="px-4 py-2">{formatDateLabel(item)}</td>
                                        <td className="px-4 py-2">{formatDayLabel(item)}</td>
                                        <td className="px-4 py-2">
                                            {item?.holiday?.name || "-"}
                                        </td>
                                        <td className="px-4 py-2">{getHolidayTypeLabel(item)}</td>
                                        <td className="px-4 py-2">
                                            <div className="flex gap-4">
                                                <button
                                                    type="button"
                                                    disabled={isInactiveBranch}
                                                    className="text-[#6941C6] hover:underline"
                                                    onClick={() => onEdit?.(item)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    type="button"
                                                    disabled={isInactiveBranch}
                                                    className="text-[#B42318] hover:underline"
                                                    onClick={() => onDelete?.(item)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}
